var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 2.4,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 13V5.5C6 5.2643 6 5.14645 6.07322 5.07322C6.14645 5 6.2643 5 6.5 5H10.382C10.6827 5 10.833 5 10.9538 5.07467C11.0747 5.14935 11.1419 5.28383 11.2764 5.55279L11.7236 6.44721C11.8581 6.71617 11.9253 6.85065 12.0462 6.92533C12.167 7 12.3173 7 12.618 7H17.5C17.7357 7 17.8536 7 17.9268 7.07322C18 7.14645 18 7.2643 18 7.5V14.5C18 14.7357 18 14.8536 17.9268 14.9268C17.8536 15 17.7357 15 17.5 15H12.618C12.3173 15 12.167 15 12.0462 14.9253C11.9253 14.8507 11.8581 14.7162 11.7236 14.4472L11.2764 13.5528C11.1419 13.2838 11.0747 13.1493 10.9538 13.0747C10.833 13 10.6827 13 10.382 13H6ZM6 13V19",
    stroke: "#0035ff",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishFlagIcon);
export default __webpack_public_path__ + "static/media/finish-flag-icon.a80c854cf51972d063848d39a4e39f83.svg";
export { ForwardRef as ReactComponent };